import styled from 'styled-components'

import Background from '../../atoms/Background'

const Main = styled(Background).attrs({
  as: 'main',
})`
  position: relative;
  flex: 1 1 auto;
`

export default Main
